// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgIconStyle from "../../../components/SvgIconStyle";
import Label from "../../../components/Label";
import { PERM } from "../../../guards/perms";
import { useTranslation } from "react-i18next";
import Image from "../../../components/Image";
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const getIconPng = (name) => (
  <Image src={`/static/icons/${name}.png`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: getIcon("ic_dashboard"),
  supervisor: getIcon("ic_supervisor"),
  agent: getIcon("ic_agent"),
  customer: getIcon("ic_customer"),
  security_and_limit: getIcon("ic_security_and_limit"),
  user: getIcon("ic_user"),
  ticket: getIconPng("ticket"),
  report: getIcon("ic_report"),
  configuration: getIconPng("configuration"),
  vendor: getIconPng("vendor"),
  refund: getIconPng("refund"),
  edit_money: getIconPng("edit_money"),
};

const NavConfig = () => {
  const { t } = useTranslation();
  const navConfig = [
    // GENERAL
    {
      subheader: t("sideBar.OVERVIEW"),
      items: [
        {
          title: t("sideBar.OVERVIEW"),
          path: PATH_DASHBOARD.general.app,
          icon: ICONS.dashboard,
        },
        {
          title: t("sideBar.supervisor"),
          path: PATH_DASHBOARD.supervisor.root,
          icon: ICONS.supervisor,
          perm: PERM.SUPERVISOR_LIST,
          children: [
            {
              title: t("sideBar.add_supervisor"),
              path: PATH_DASHBOARD.supervisor.add,
              perm: PERM.SUPERVISOR_CREATE,
            },
            {
              title: t("sideBar.list_supervisor"),
              path: PATH_DASHBOARD.supervisor.list,
              perm: PERM.SUPERVISOR_LIST,
            },
          ],
        },
        {
          title: t("sideBar.vendor"),
          path: PATH_DASHBOARD.agent.root,
          icon: ICONS.vendor,
          perm: PERM.VENDOR_LIST,
          children: [
            {
              title: t("sideBar.add_vendor"),
              path: PATH_DASHBOARD.agent.add,
              perm: PERM.VENDOR_CREATE,
            },
            {
              title: t("sideBar.list_vendor"),
              path: PATH_DASHBOARD.agent.list,
              perm: PERM.VENDOR_LIST,
            },
          ],
        },
        {
          title: t("p_ticket.cancelTicket"),
          path: PATH_DASHBOARD.ticket.refund,
          icon: ICONS.refund,
          perm: PERM.TICKET_CANCEL,
        },
        {
          title: t("p_ticket.editTicket"),
          path: PATH_DASHBOARD.ticket.edit_ticket,
          icon: ICONS.edit_money,
          perm: PERM.TICKET_EDIT,
        },
      ],
    },

    // TRANSACTIONS
    {
      subheader: t("sideBar.TRANSACTIONS"),
      items: [
        {
          title: t("params.all_transaction"),
          path: PATH_DASHBOARD.configuration.root,
          icon: ICONS.ticket,
          perm: PERM.TICKET_SALE,
          children: [
            {
              title: t("sideBar.ticket_sale"),
              path: PATH_DASHBOARD.ticket.sale,
              icon: ICONS.ticket,
              perm: PERM.TICKET_SALE,
            },
            {
              title: t("sideBar.report_sale"),
              path: PATH_DASHBOARD.report.sale,
              icon: ICONS.report,
              perm: PERM.REPORT_SALE,
            },
            {
              title: t("sideBar.commission_distribution"),
              path: PATH_DASHBOARD.report.commission_distribution,
              icon: ICONS.report,
              perm: PERM.COMMISSION_PAY,
            },
            {
              title: t("params.all_transaction"),
              path: PATH_DASHBOARD.report.transactions,
              icon: ICONS.report,
              perm: PERM.TRANSACTIONS_LIST,
            },
          ],
        },
      ],
    },

    // CONFIGURATION
    {
      subheader: t("sideBar.configuration"),
      items: [
        {
          title: t("sideBar.configuration"),
          path: PATH_DASHBOARD.configuration.root,
          icon: ICONS.configuration,
          perm: PERM.CONFIG_EXCHANGE_RATE_VIEW,
          children: [
            {
              title: t("p_usercommission.usercommission"),
              path: PATH_DASHBOARD.configuration.usercommission,
              perm: PERM.CONFIG_USER_COMMISSION_VIEW,
            },
            {
              title: t("sideBar.exchange_rate"),
              path: PATH_DASHBOARD.configuration.exchange_rate,
              perm: PERM.CONFIG_EXCHANGE_RATE_VIEW,
            },
            {
              title: t("sideBar.feegenerale"),
              path: PATH_DASHBOARD.configuration.fee,
              perm: PERM.CONFIG_FEE_VIEW,
            },
            {
              title: t("sideBar.limit_transaction_generale"),
              path: PATH_DASHBOARD.security_and_limit
                .limit_transaction_generale,
              perm: PERM.CONFIG_LIMIT_GENERAL_VIEW,
            },
          ],
        },
      ],
    },

    // PARAMETTRE
    {
      subheader: "Paramettre",
      items: [
        {
          title: t("sideBar.user"),
          path: PATH_DASHBOARD.user.account,
          icon: ICONS.user,
        },
      ],
    },
  ];

  return navConfig;
};

export default NavConfig;
